import {Trans} from '@lingui/macro';
import React from 'react';

import {
  VirtualTableColumnCellsEnum,
  virtualTableRowCheckboxWrapperWidth,
} from '../../../components/common/table/helpers/tableHelpers';
import {getPreviewerEmojiDefinition} from '../../../models/api/previewerHelpers';
import {PreviewerModel} from '../../../models/api/previewerModel';
import {ResourceColumn, ResourceTableColumnTypesEnum} from '../commons/resourceTableTypes';

export enum PreviewersTableColumnIdsEnum {
  NAME = 'name',
  DOMAIN = 'domain',
  DESCRIPTION = 'description',
  CREATED_DATE = 'created_date',
}

export const previewersTableColumns: ReadonlyArray<ResourceColumn<PreviewerModel>> = [
  {
    id: PreviewersTableColumnIdsEnum.DOMAIN,
    type: ResourceTableColumnTypesEnum.NAME,
    title: <Trans id="previewers-table-column-domain">Domain name</Trans>,
    accessor: (previewer) => previewer.domain,
    emojiDefinitionAccessor: (previewer) => getPreviewerEmojiDefinition(previewer.linkType),
    cellType: VirtualTableColumnCellsEnum.TEXT,
    settings: {
      sticky: {
        isSticky: true,
        stickyOffset: virtualTableRowCheckboxWrapperWidth,
      },
      cellWidth: {
        width: 200,
      },
    },
  },
  {
    id: PreviewersTableColumnIdsEnum.DESCRIPTION,
    type: ResourceTableColumnTypesEnum.TEXT,
    title: <Trans id="previewers-table-column-description">Description</Trans>,
    accessor: (previewer) => previewer.description ?? '',
    cellType: VirtualTableColumnCellsEnum.TEXT,
    settings: {
      cellWidth: {
        shouldFillRemainingWidth: true,
      },
    },
  },
  {
    id: PreviewersTableColumnIdsEnum.CREATED_DATE,
    type: ResourceTableColumnTypesEnum.DATE,
    title: <Trans id="previewers-table-column-createddate">Date created</Trans>,
    accessor: (previewer) => previewer.createdAt,
    customFormat: {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    },
    cellType: VirtualTableColumnCellsEnum.DATE,
    settings: {
      cellWidth: {
        width: 152,
      },
    },
  },
];
